import { useCurrentUser } from './useCurrentUser';
import { APIPermission } from '../../Api';

/**
 * API permissions list in common\src\services\UserService\Api\ViewModels\APIPermissionViewModel.ts
 */
export function useUserHasPermission(permission: APIPermission | APIPermission[]) {
    const currentUser = useCurrentUser();
    if (!currentUser) {
        return false;
    }

    const permissionsToCheck = Array.isArray(permission) ? permission : [permission];

    return permissionsToCheck.every((p) => currentUser.apiPermissions.has(p));
}

export type UseUserHasPermission = typeof useUserHasPermission;
